import i18n from 'services/base/i18n';

export default {
  // Label that appears above the input box that asks the user to provide a IP address to block
  customIP: () => i18n.pgettext('Components|Parental Controls|Custom Website', 'Please provide a valid IP address (e.g. 172.16.10.12)'),
  // Label that appears above the input box that asks the user to provide a website to block
  customDomain: () => i18n.pgettext('Components|Parental Controls|Custom Website', 'Please provide a valid website name (e.g. facebook.com)'),
  // Accept button on the custom website form
  saveCustom: () => i18n.pgettext('Components|Parental Controls|Custom Website', 'OK'),
  // An error message that appears when the user tries to input an invalid website/domain name
  invalidDomain: () => i18n.pgettext('Components|Parental Controls|Custom Website', 'Invalid website'),
  // An error message that appears when the user tries to input an invalid IP address
  invalidIP: () => i18n.pgettext('Components|Parental Controls|Custom Website', 'Invalid IP address'),
};
